
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { TechniquesTable } from '@/components/admin/TechniquesTable';
import { AdminHeader } from '@/components/admin/AdminHeader';

import { useIsMobile } from '@/hooks/use-mobile';
import { CircleHelp } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogClose } from '@/components/ui/dialog';

const Admin = () => {
  const isMobile = useIsMobile();
  const [helpOpen, setHelpOpen] = useState(false);

  const helpContent = {
    title: 'Admin Dashboard Help',
    description: 'Manage app content and monitor system health',
    content: (
      <>
        <p>Welcome to the Admin Dashboard! Here you can:</p>
        <ul className="list-disc pl-5 space-y-2">
          <li>Manage technique library content and categories</li>
          <li>Review and moderate user-generated content</li>
          <li>Monitor system performance and user activity</li>
          <li>Manage user accounts and permissions</li>
          <li>View analytics and reporting data</li>
        </ul>
        <p>Use these tools to maintain the quality and performance of The Mat Monster platform.</p>
      </>
    ),
  };

  return (
    <>
      <div className="container mx-auto px-4 py-8">
        {!isMobile && (
          <div className="flex items-center justify-between mb-6">
            <h1 className="text-2xl font-bold">Admin Dashboard</h1>
            <CircleHelp
              className="h-6 w-6 text-primary cursor-pointer hover:text-primary/80 transition-colors"
              onClick={() => setHelpOpen(true)}
              strokeWidth={2}
            />
          </div>
        )}

        {/* Only show AdminHeader and TechniquesTable on desktop, mobile uses MainLayout header */}
        {!isMobile && <AdminHeader />}
        <TechniquesTable />

        {/* Help dialog for desktop */}
        {!isMobile && (
          <Dialog open={helpOpen} onOpenChange={setHelpOpen}>
            <DialogContent className="sm:max-w-md">
              <DialogHeader>
                <DialogTitle>{helpContent.title}</DialogTitle>
                <DialogDescription>{helpContent.description}</DialogDescription>
              </DialogHeader>
              <div className="space-y-4">{helpContent.content}</div>
              <div className="flex justify-end">
                <DialogClose asChild>
                  <Button variant="default" size="sm">
                    Got it
                  </Button>
                </DialogClose>
              </div>
            </DialogContent>
          </Dialog>
        )}
      </div>
    </>
  );
};

export default Admin;
